import { render, staticRenderFns } from "./ForceRefresh.vue?vue&type=template&id=fca3cf28&"
import script from "./ForceRefresh.vue?vue&type=script&lang=ts&"
export * from "./ForceRefresh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports